import { useEffect, useState } from 'react';

type HealthStatus =  "ok" | "warning" | "error";

export function useHealthcheck() {
  const [status, setStatus] = useState<HealthStatus>('ok');

  const endpoint = process.env.REACT_APP_API_URL as string;

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ query: '{ __typename }' }),
        });

        const json = await res.json();

        if (json.data && json.data.__typename) {
          setStatus('ok');
        } else {
          setStatus('error');
        }
      } catch {
        setStatus('error');
      }
    };

    checkHealth();
  }, [endpoint]);

  return status;
}
